import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex',
    tab: 'h-10 w-1/2 normal-case',
    title: 'heading-3xl mb-6 font-bold lg:mb-8',
    informer:
      'bg-label-green heading-s-bold mt-15 rounded-[12px] px-5 py-4 text-white transition-transform duration-500 ease-out'
  },
  variants: {
    color: {
      primary: 'text-black'
    },
    informerState: {
      hidden: {
        informer: 'pointer-events-none -translate-y-100 opacity-0'
      },
      visible: {
        informer: 'translate-y-0 opacity-100'
      }
    }
  },
  defaultVariants: {
    color: 'primary',
    informerState: 'hidden'
  }
});
